import FileUploader from 'components/FileUploader/FileUploader'
import React, { useContext } from 'react'
import { AppContext } from 'context/appContext'
import { disableDragFilesTitles, WIZARD_STAGES_ID } from 'utils/constants'
import { Field } from 'react-final-form'
import { getFileProps } from '../../helpers'
import { IFileItem, IFileUploaderGroup } from '../../interface'
import { IFileSelected } from 'components/FileUploader/interface'
import { useTranslation } from 'react-i18next'

const T_ROOT = "documents"

export const DocumentsFileUploaderGroup = ({
  failUpload,
  fileMaxSizeAllowed,
  files,
  fileTypes,
  handleDocumentSubmit,
  hasInternationalDoc,
  hasKycProblem,
  isLoadingFile
}: IFileUploaderGroup): JSX.Element => {
  const { t } = useTranslation()
  const { wizardSavedData } = useContext(AppContext)

  const handleSubmitDocument = (e: IFileSelected, key: number): void => {
    e.index = key
    handleDocumentSubmit(e)
  }

  const handlePreloadedFile = (input: any): IFileSelected | undefined => {
    try {
      if (files.length) {
        const fileFilter = files.filter((file: any) => file.idReferenceFile && file.fileClassificationId === input.name)
        if (fileFilter.length) {
          const highestVersionFile = fileFilter[0]
          return {
            file: {
              ...highestVersionFile,
              path: highestVersionFile.name,
              type: highestVersionFile.mimeType,
              webkitRelativePath: ''
            },
            isFilePreloaded: true,
            rejected: false
          }
        }
      }
      return { file: undefined, rejected: false }
    } catch (error) {
      console.error(error)
    }
  }

  const renderFileUploader = (file: IFileItem, key: number): React.ReactElement => {
    const { fileClassificationId: id, title } = file
    const { disabled, file_types, maxSize, tooltip } = getFileProps(
      fileMaxSizeAllowed,
      file,
      fileTypes,
      hasInternationalDoc,
      hasKycProblem,
      t
    )
    const disableDragFile = disableDragFilesTitles.includes(title)
    const defaultValue = wizardSavedData[WIZARD_STAGES_ID.documents].hasData
      ? wizardSavedData[WIZARD_STAGES_ID.documents].data[id]
      : ''

    return (
      <Field name={id} key={key} defaultValue={defaultValue} type='file'>
        {({ input, meta }): React.ReactElement => (
          <fieldset>
            <FileUploader
              title={t(`${T_ROOT}.documents.${title}.title`)}
              disabled={disabled}
              input={input}
              meta={meta}
              tooltip={tooltip}
              fileTypes={file_types}
              fileTitle={t(`${T_ROOT}.documents.${title}.title`)}
              maxSize={maxSize}
              noDrag={disableDragFile}
              onSubmitDocument={(file: IFileSelected): void => handleSubmitDocument(file, key)}
              preloadedFile={(): IFileSelected | undefined => handlePreloadedFile(input)}
              filesEntity={files}
              isFailUpload={failUpload[file.fileClassification]}
              loading={isLoadingFile ? isLoadingFile[file.fileClassification] : false}
            />
          </fieldset>
        )}
      </Field>
    )
  }

  return <>{files?.map((file: IFileItem, key: number) => renderFileUploader(file, key))}</>
}
